import { defineMessages } from 'react-intl';

/** The Work chip and panel on Studio (design navigation-v2 c 3e). */
export const studioWorkPanelMessages = defineMessages({
  chipSeparator: { id: 'app.sml.promote.studio.workChip.separator', defaultMessage: '{working} · {failed}' },
  chipHint: { id: 'app.sml.promote.studio.workChip.hint', defaultMessage: 'Open the work list' },
  close: { id: 'app.sml.promote.studio.workPanel.close', defaultMessage: 'Close the work list' },
});
